<template>
  <div class="checkbox-row">
    <input
      :id="checkbox.id"
      type="checkbox"
      :name="checkbox.name"
      :value="getStoreValue"
      class="checkbox-row__input"
      :checked="getStoreValue"
      @change="updateProperty"
    />
    <label class="checkbox-row__label" :for="checkbox.id">
      <div class="checkbox-row__fake-checkbox"></div>
      {{ checkbox.label }}
      <slot />
    </label>
  </div>
</template>

<script>
import { get } from "lodash";
export default {
  props: {
    checkbox: Object,
  },

  computed: {
    getStoreValue() {
      const checkbox = this.$props.checkbox;
      const { type, name } = checkbox;
      // Default to the value, which we'll keep if it's not an object
      const typeEntry = get(this.$store.state.incidentReport, type);
      let value = typeEntry;
      // If it is an object, though, we get the right property
      if (typeof typeEntry === "object") {
        value = get(typeEntry, name);
      }
      return value;
    },
  },

  methods: {
    getAndUpdatedCheckboxes(type, event) {
      const checkboxes = this.$store.state.incidentReport[type];
      const name = event.target.name;
      const checked = event.target.checked;
      checkboxes[name] = checked;
      return checkboxes;
    },
    updateSymptoms(event) {
      const symptoms = this.getAndUpdatedCheckboxes("symptoms", event);
      this.$store.commit("incidentReport/setSymptoms", symptoms);
    },
    updateWaterProximity(event) {
      const waterProximity = this.getAndUpdatedCheckboxes(
        "waterProximity",
        event
      );
      this.$store.commit("incidentReport/setWaterProximity", waterProximity);
    },
    updatePhoto(event) {
      this.$store.commit("incidentReport/setPhoto", event.target.checked);
    },
    updateProperty(event) {
      const type = this.$props.checkbox.type;
      if (type === "symptoms") {
        this.updateSymptoms(event);
      } else if (type === "waterProximity") {
        this.updateWaterProximity(event);
      } else if (type === "photo") {
        this.updatePhoto(event);
      }
    },
  },
};
</script>

<style lang="scss">
.checkbox-row {
  align-items: center;
  display: flex;
  & ~ & {
    margin-top: 0.5rem;
    @include tablet {
      margin-top: 0;
    }
  }
  &__input {
    appearance: none;
    width: 0;
    height: 0;
  }
  &__label {
    display: flex;
    align-items: center;
  }
  &__fake-checkbox {
    background-color: white;
    border: 2px solid get-color("grey", 400);
    display: inline-block;
    height: 1.75rem;
    margin-right: 0.5rem;
    width: 1.75rem;
    .checkbox-row__input:checked + .checkbox-row__label & {
      background-color: $darkgreen;
    }
    .checkbox-row__input:focus + .checkbox-row__label & {
      outline: $darkgreen auto 5px;
    }
  }
  &--full {
    grid-column: span 2;
  }
}
</style>
